import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

const INBOX_ROUTES = new Set(['brand.inbox'])

export const checkInboxFeatureFlag: HermesGuardFn = async (to) => {
  if (typeof to.name !== 'string' || !INBOX_ROUTES.has(to.name)) {
    return undefined
  }

  const featureFlags = useFeatureFlags()

  if (
    !featureFlags.isEnabled('hermes.inbox') &&
    !featureFlags.isEnabled('hermes.internalInbox')
  ) {
    return {
      name: 'brand.home',
      params: { brandId: to.params.brandId },
    }
  }

  return undefined
}
